@if (scheduledTasks !== null && scheduledTasks !== undefined && scheduledTasks.length > 0) {
<div id="scheduled-tasks-panel"
     class="bg-white border m-2 pt-3 px-3 d-flex flex-column shadow-sm">
  <div class="border-bottom pb-1">
    <strong class="text-primary">Scheduled tasks</strong>
  </div>
  @for (scheduledTask of scheduledTasks; track scheduledTask.messageId) {
  <div class="row">
    <div class="col small pt-2">
      <span class="fw-bold"
            [class.text-secondary]="scheduledTask.status === 'Active'">{{
        convertScheduledTask(scheduledTask.task) }}
      </span>
    </div>
    <div class="col-auto">
      @if (scheduledTask.status === 'Scheduled') {
      <button type="button"
              class="btn btn-outline-primary border-0 px-1 py-0"
              (click)="deleteScheduledTask(scheduledTask)">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
      </button>
      }
    </div>
  </div>
  }
  <div class="pt-2 pb-2">
    <era-device-scheduled-tasks-cancel></era-device-scheduled-tasks-cancel>
  </div>
</div>
}